import React from 'react';
import PropTypes from 'prop-types';
import { Chevron, ScrollBar } from 'components/atoms';
import './CardScrollControls.scss';

const CardScrollControls = ({
	onLeftClick,
	onRightClick,
	onLeftKeyDown,
	onRightKeyDown,
	trackRef,
	thumbRef,
}) => (
	<div className="card-scroll-bar-wrapper">
		<Chevron
			direction="left"
			onClick={onLeftClick}
			onKeyDown={onLeftKeyDown}
			aria-label="previous"
		/>
		<ScrollBar
			trackRef={trackRef}
			thumbRef={thumbRef}
		/>
		<Chevron
			direction="right"
			onClick={onRightClick}
			onKeyDown={onRightKeyDown}
			aria-label="next"
		/>
	</div>
);

CardScrollControls.propTypes = {
	onLeftClick: PropTypes.func.isRequired,
	onRightClick: PropTypes.func.isRequired,
	onLeftKeyDown: PropTypes.func.isRequired,
	onRightKeyDown: PropTypes.func.isRequired,
	trackRef: PropTypes.oneOfType([
		PropTypes.func,
		PropTypes.shape({
			current: PropTypes.object,
		}),
	]).isRequired,
	thumbRef: PropTypes.oneOfType([
		PropTypes.func,
		PropTypes.shape({
			current: PropTypes.object,
		}),
	]).isRequired,
};

export default CardScrollControls;
